import * as React from 'react';
import { SVGProps } from 'react';

export const Mattress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.3525 17.127L15.7497 22.8867L2.5 17.5"
      stroke="#071114"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 27.2426V22.8867"
      stroke="#071114"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5 13.5L28.7636 16.6528C29.2546 16.775 29.5002 17.2639 29.5002 17.7528V20.6861C29.5002 21.175 29.2546 21.5418 28.7636 21.7861L16.2412 27.164C15.8728 27.2863 15.6273 27.2863 15.259 27.164L2.73661 21.7861C2.24554 21.664 2 21.175 2 20.6861V17.7528C2 17.2639 15.0089 12.744 15.5 12.4995"
      stroke="#071114"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2212 5H22.7118L19.0029 10.2359H22.9299"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1455 14H19.4725L17 17.4907H19.618"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Mattress;
